<template>
    <div class="fcf-check__row fcf-check__row--data">
        <div class="fcf-check__cell">{{descriptions[localId]}}</div>
        <div class="fcf-check__cell fcf-check__cell--center">
            <div class="field">
                <b-checkbox v-model="localValue" :disabled="editNotAllowed"/>
            </div>
        </div>
        <div class="fcf-check__cell fcf-check__cell--center" v-if="hasNa">
            <div class="field">
                <b-checkbox v-model="localNaValue" :disabled="editNotAllowed"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FcfCheckRow',
  props: [
    'id',
    'value',
    'hasNa',
    'naValue',
    'naId',
    'editNotAllowed'
  ],
  data () {
    return {
      localId: this.id,
      localValue: this.value === undefined ? false : this.value,
      localNaValue: this.naValue,
      descriptions: {
        'physicalFilesCollected': 'All physcial files, if there are any, (including all working files) have been collected from all relevant colleagues involved in the matter',
        'staffInformed': 'All lawyers, paralegals and secretaries have been informed of the matter being in the process of closing and that there are no documents relating to the matter remain in their possession',
        'emailsCollected': 'The relevant public folder of the matter contains a complete record of all emails of the fee earners involved in the matter',
        'documentsDmSaved': 'All documents, charts, spreadsheets of the matter have been properly saved in DM under the WorkflowMax number',
        'originalsReturned': 'All original documents (if any) have been returned to the client / relevant party',
        'archiveAndUsbCreated': 'The Archive Box Folder contains a complete record of all the emails and documents of the matter and a USB drive has been created',
        'knowHowPassed': 'A set of electronic copy of all know-how prepared for the matter have been passed to the partner in charge for record',
        'marketingPassed': 'A set of electronic copy of all marketing materials prepared for the matter have been passed to the partner in charge for record',
        'signedMandatePassed': 'The original / copy of the signed mandate letter has been passed to the accounts department',
        'kycFiled': 'All original / certified copies of the KYC documents received have been properly filed in the KYC master files',
        'bibleCompleted': 'The bible of the matter has been completed (or with special permission that a bible is not required, e.g. provision of company secretarial services) and a bible number has been assigned and the bible has been saved in L:Library and Box',
        'accountsDepInformed': 'The accounts department of the firm has been informed of the matter being in the process of closing and no objection from the accounts department has been received'
      }
    }
  },
  watch: {
    id () {
      this.localId = this.id
    },
    value () {
      this.localValue = this.value
    },
    naValue () {
      this.localNaValue = this.naValue
    },
    localValue () {
      if (this.value !== this.localValue) {
        this.$emit('value-changed', this.localId, this.localValue)
      }
    },
    localNaValue () {
      if (this.naValue !== this.localNaValue) {
        this.$emit('value-changed', this.naId, this.localNaValue)
      }
    }
  },
  methods: {
    onRowClick () {
      this.localValue = !this.localValue
    }
  }
}
</script>

<style scoped>

.fcf-check__row--data:hover {
  background-color: #fafafa;
  /* cursor: pointer; */
}

.fcf-check__cell {}
.fcf-check__cell--center {
  text-align: center;
}
</style>
